import { GovernanceWorkspace } from '@/components/governance/governance-workspace'

export function OperationsPolls() {
  return <GovernanceWorkspace basePath="/operations/polls" />
}
